/* eslint-disable */
import { useEffect, useState, useContext } from 'react';

import {
  CardHeader,
  Typography,
  IconButton,
  Drawer,
  Link,
  Button,
  Paper,
  useTheme,
} from '@mui/material';

import { Close } from '@mui/icons-material';

import { ContactForm } from '../ContactForm';
import ContactDrawerSkeleton from '../ContactDrawerSkeleton';
import ModalImageCors from '../ModalImageCors';

import formatSerializedId from '../../utils/formatSerializedId';
import { i18n } from '../../translate/i18n';

import { AuthContext } from '../../context/Auth/AuthContext';
import toastError from '../../toasts/toastError';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { getStyled } from './styles';

const ContactDrawer = ({ open, handleDrawerClose, contact, loading }) => {
  const theme = useTheme();
  const classes = getStyled(theme, open);

  const [openForm, setOpenForm] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    setOpenForm(false);
  }, [open, contact]);

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      toastSuccess('Contato bloqueado');
    } catch (err) {
      toastError(err);
    }
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      toastSuccess('Contato desbloqueado');
    } catch (err) {
      toastError(err);
    }
  };

  if (loading) return null;

  return (
    <>
      <Drawer
        style={classes.drawer}
        variant='persistent'
        anchor='right'
        open={open}
        PaperProps={{ style: { position: 'absolute' } }}
        ModalProps={{
          container: document.getElementById('drawer-container'),
          style: { position: 'absolute' },
        }}
        sx={classes.drawerPaper}
      >
        <div style={classes.header}>
          <IconButton
            onClick={handleDrawerClose}
            sx={{ color: theme.custom.colors.text }}
          >
            <Close />
          </IconButton>
          <Typography
            sx={{
              justifySelf: 'center',
              color: theme.custom.colors.text,
              fontWeight: 500,
            }}
          >
            {i18n.t('contactDrawer.header')}
          </Typography>
        </div>
        {loading ? (
          <ContactDrawerSkeleton classes={classes} />
        ) : (
          <div style={classes.content}>
            <Paper square variant='outlined' style={classes.contactHeader}>
              <ModalImageCors
                imageUrl={contact?.urlPicture}
                sx={{ borderRadius: '8px' }}
              />
              <CardHeader
                style={{
                  width: '100%',
                }}
                titleTypographyProps={{
                  noWrap: true,
                  align: 'center',
                }}
                subheaderTypographyProps={{
                  noWrap: true,
                  align: 'center',
                }}
                title={
                  <>
                    <Typography
                      sx={{ color: theme.custom.colors.text, fontWeight: 500 }}
                    >
                      {contact.name}
                    </Typography>
                  </>
                }
                subheader={
                  <>
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: theme.custom.colors.text,
                      }}
                    >
                      {user.profile === 'user'
                        ? formatSerializedId(contact.number).slice(0, -6) +
                          '*-*' +
                          contact.number.slice(-2)
                        : formatSerializedId(contact.number)}
                    </Typography>
                    <Typography
                      sx={{ color: theme.custom.colors.text, fontSize: 12 }}
                    >
                      <Link href={`mailto:${contact.email}`}>
                        {contact.email}
                      </Link>
                    </Typography>
                  </>
                }
              />
              <Button
                variant='outlined'
                sx={classes.buttonEdit}
                onClick={() => setOpenForm(true)}
              >
                {i18n.t('contactDrawer.buttons.edit')}
              </Button>
              <Button
                variant='outlined'
                sx={classes.buttonBlock}
                onClick={() =>
                  contact.active
                    ? handleBlockContact(contact.id)
                    : handleUnBlockContact(contact.id)
                }
                disabled={loading}
              >
                {!contact.active ? 'Desbloquear contato' : 'Bloquear contato'}
              </Button>
              {contact.id && openForm && (
                <ContactForm
                  initialContact={contact}
                  onCancel={() => setOpenForm(false)}
                />
              )}
            </Paper>
          </div>
        )}
      </Drawer>
    </>
  );
};

export default ContactDrawer;
